import React, { useState } from 'react';
import { Modal } from 'antd';
import { InfoCircleOutlined } from '@ant-design/icons';
import { BREAKPOINTS, FONT_WEIGHT } from '@app/styles/themes/constants';
import styled from 'styled-components';

const MOBILE_MAX = BREAKPOINTS.md;

const Wrapper = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 6px;
  width: 100%;
  min-width: 0;

  @media (max-width: ${MOBILE_MAX}px) {
    align-items: center;
  }
`;

const Text = styled.div<{ $size: 'sm' | 'md' }>`
  color: #8c8c8c;
  font-size: ${({ $size }) => ($size === 'sm' ? '12px' : '13px')};
  font-weight: ${FONT_WEIGHT.light};
  line-height: 1.3;
  flex: 1 1 auto;
  min-width: 0;
  margin-top: 2px;
  white-space: normal;
  overflow-wrap: anywhere;
  word-break: break-word;

  @media (max-width: ${MOBILE_MAX}px) {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    overflow-wrap: normal;
    word-break: normal;
    margin-top: 0;
  }
`;

const InfoBtn = styled.button`
  display: none;
  background: transparent;
  border: none;
  padding: 4px;
  margin: 0;
  color: #1a295a;
  cursor: pointer;
  font-size: 18px;
  line-height: 1;
  align-items: center;
  justify-content: center;
  flex: 0 0 auto;
  z-index: 2;
  position: relative;

  @media (max-width: ${MOBILE_MAX}px) {
    display: inline-flex;
  }
`;

const ModalTitle = styled.div`
  font-size: 18px;
  font-weight: ${FONT_WEIGHT.extraBold};
  color: #1a295a;
  margin-bottom: 12px;
  padding-inline-end: 24px;
  word-break: break-word;
`;

const ModalBody = styled.div`
  color: #37352f;
  font-size: 14px;
  font-weight: ${FONT_WEIGHT.regular};
  line-height: 1.5;
  white-space: pre-wrap;
  word-break: break-word;
`;

interface DescriptionTextProps {
  description: string;
  title?: string;
  size?: 'sm' | 'md';
}

export const DescriptionText: React.FC<DescriptionTextProps> = ({ description, title, size = 'sm' }) => {
  const [open, setOpen] = useState(false);

  if (!description) return null;

  return (
    <Wrapper onClick={(e) => e.stopPropagation()}>
      <Text $size={size}>{description}</Text>
      <InfoBtn
        type="button"
        aria-label="Show description"
        onClick={(e) => {
          e.stopPropagation();
          setOpen(true);
        }}
      >
        <InfoCircleOutlined />
      </InfoBtn>
      <Modal open={open} onCancel={() => setOpen(false)} footer={null} centered destroyOnClose title={null} closable>
        {title && <ModalTitle>{title}</ModalTitle>}
        <ModalBody>{description}</ModalBody>
      </Modal>
    </Wrapper>
  );
};
